import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useState } from 'react';

ChartJS.register(ArcElement, Tooltip, Legend);

const data = {
    labels: ['Pop Quizzes', 'Tests / Exams', 'Assignments', 'Announcements',],
    datasets: [
        {
            label: '# of Votes',
            data: [16, 5, 2, 5],
            backgroundColor: [
                'rgba(75, 88, 121, 1)',
                'rgba(88, 183, 194, 1)',
                'rgba(211, 81, 143, 1)',
                'rgba(230, 200, 120, 1)',
            ],
            borderWidth: 1,

        },
    ],
};

const TasksChart = () => {
    const [chartData, setChartData] = useState(data)
    return <div style={{
        padding: '2rem'
    }}>
        <Doughnut data={chartData} options={{
            plugins: {
                legend: {
                    position: 'bottom',
                    align: 'center'
                }
            }
        }
        } />
    </div>
}

export default TasksChart
